/**
 * PreviewMethoden — Methoden (methods/process) content page
 */

interface PreviewMethodenProps {
  settings: {
    pageMethoden?: {
      sections?: Record<string, boolean>;
      heroTitle?: string;
      heroSubtitle?: string;
      introText?: string;
      steps?: Array<{
        icon?: string;
        title?: string;
        text?: string;
      }>;
      tools?: Array<{
        name?: string;
        description?: string;
      }>;
      philosophyTitle?: string;
      philosophyText?: string;
    };
    [key: string]: any;
  };
  components: any;
}
export function PreviewMethoden({ settings, components }: PreviewMethodenProps) {
  const page = settings.pageMethoden || {};
  const sec = page.sections || {};
  const steps = page.steps || [];
  const tools = page.tools || [];

  return (
    <div className="content-page">
      <div className="preview-container">
        <section className="content-page__hero">
          <h1>{page.heroTitle || "Unsere Methodik"}</h1>
          <p>{page.heroSubtitle || ""}</p>
        </section>

        {sec.intro !== false && page.introText && (
          <section className="content-section">
            <p className="content-section__text">{page.introText}</p>
          </section>
        )}

        {sec.steps !== false && (
          <section className="method-steps">
            {steps.map((step, i) => (
              <div key={i} className="method-step">
                <div className="method-step__icon">{step.icon || (i + 1)}</div>
                <div className="method-step__content">
                  <h3>{step.title}</h3>
                  <p>{step.text}</p>
                </div>
              </div>
            ))}
          </section>
        )}

        {sec.tools !== false && tools.length > 0 && (
          <section className="content-section">
            <h2 className="content-section__title">Unsere Tools</h2>
            <div className="tools-grid">
              {tools.map((tool, i) => (
                <div key={i} className="tool-card">
                  <div className="tool-card__name">{tool.name}</div>
                  <div className="tool-card__desc">{tool.description}</div>
                </div>
              ))}
            </div>
          </section>
        )}

        {sec.philosophy !== false && page.philosophyTitle && (
          <section className="page-cta">
            <h2>{page.philosophyTitle}</h2>
            <p>{page.philosophyText || ""}</p>
          </section>
        )}
      </div>
    </div>
  );
}
